export const roundCurrency = (amount) => {
	const roundedAmount = Number(amount).toFixed(3)

	return roundedAmount
}
